const TextZone = ({ title, width, height }) => {
  return (
    <div
      className={`${width} ${height} shadow-lg relative   drop-shadow-2xl  rounded-[16px] border-[#FFFFFF] border-[1px] `}
    >
      <div
        className={`w-full pointer-events-none absolute top-0 left-[2px] right-[2px] h-3  bg-gradient-to-b from-gray-300 to-transparent rounded-t-[16px]`}
      ></div>
      <h2
        className={`w-full  ${height} overflow-hidden flex items-center px-6 rounded-[16px]`}
      >
        {title}
      </h2>
    </div>
  );
};
export default TextZone;
